import React, { useMemo, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import { useTranslation } from "react-i18next";

const Statement: React.FC = () => {
  const { t } = useTranslation();
  const controls = useAnimation();

  const text = t("statement.text");

  const [isPaused, setIsPaused] = useState(false);

  // Contenu répété (meilleur pour marquee fluide)
  const items = useMemo(() => [...Array(4)], []);

  const startAnimation = async () => {
    setIsPaused(false);
    await controls.start({
      x: ["0%", "-50%"],
      transition: {
        duration: 65,
        repeat: Infinity,
        ease: "linear",
      },
    });
  };

  const stopAnimation = async () => {
    setIsPaused(true);
    await controls.stop();
  };

  // Démarre au mount
  React.useEffect(() => {
    startAnimation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="relative py-12 sm:py-16 bg-stone-900 text-cream border-y border-stone-800 overflow-hidden">
      <div className="relative overflow-hidden">
        <motion.div
          className="flex w-max items-center marquee-track"
          animate={controls}
          onHoverStart={stopAnimation}
          onHoverEnd={startAnimation}
          style={{
            cursor: "default",
            opacity: isPaused ? 0.95 : 1,
            gap: "2.5rem" // gap-10
          }}
        >
          {/* ====== Bloc 1 & 2 fusionnés pour éviter les coupures de gap ====== */}
          {[...items, ...items].map((_, i) => (
            <React.Fragment key={`marquee-${i}`}>
              <h2
                className="
                  font-oswald text-3xl md:text-5xl lg:text-[4rem] uppercase font-light tracking-[0.2em]
                  text-transparent stroke-text
                  opacity-40 hover:opacity-100
                  transition-all duration-700
                  whitespace-nowrap leading-[1.2] py-2
                "
              >
                {text}
              </h2>

              {/* SEPARATOR (Étoile / Diamant épuré) */}
              <div className="relative w-10 h-10 flex items-center justify-center opacity-40">
                <div className="absolute inset-0 rounded-full border border-gold/10 blur-md" />
                <div className="w-2 h-2 bg-gold rotate-45 shadow-[0_0_20px_#a5694f]" />
              </div>
            </React.Fragment>
          ))}
        </motion.div>
      </div>

      {/* LOCAL STYLES */}
      <style>{`
        .stroke-text {
          -webkit-text-stroke: 1px rgba(244, 237, 227, 0.4);
        }

        .stroke-text:hover {
          -webkit-text-stroke: 1.5px #a5694f;
          color: #a5694f;
          text-shadow: 0 0 25px rgba(165, 105, 79, 0.3);
        }
      `}</style>
    </section>
  );
};

export default Statement;
